module.exports = __webpack_public_path__ + "LatoLatin-Bold.f323edeea9058ded9814.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.woff
// module chunks = styles